import React, { ReactNode, MouseEvent, useEffect, RefObject } from 'react';

import { Paper, Popper } from '@material-ui/core';
interface IOwnProps {
    id: string;
    children: ReactNode;
    anchorEl: null | HTMLElement;
    setAnchorEl: (value: null | HTMLElement) => void;
    popperRef: RefObject<HTMLDivElement>;
}

const PopperWrapper = ({
    children,
    anchorEl,
    setAnchorEl,
    popperRef,
    id,
}: IOwnProps) => {
    const open = Boolean(anchorEl);
    const handleClose = () => {
        setAnchorEl(null);
    };
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (
                anchorEl &&
                popperRef.current &&
                !popperRef.current.contains(event.target as Node) &&
                !anchorEl.contains(event.target as Node)
            ) {
                handleClose();
            }
        };

        document.addEventListener(
            'mousedown',
            handleClickOutside as unknown as EventListener
        );
        return () => {
            document.removeEventListener(
                'mousedown',
                handleClickOutside as unknown as EventListener
            );
        };
    }, [anchorEl]);

    return (
        <Popper
            id={id}
            open={open}
            anchorEl={anchorEl}
            placement="bottom"
            transition
            disablePortal
            onClick={handleClose}
            style={{
                zIndex: 9999,
            }}
        >
            <Paper
                ref={popperRef}
                elevation={8}
                style={{
                    padding: '8px 0',
                    marginTop: 4,
                    minWidth: anchorEl?.offsetWidth || 160,
                }}
            >
                {children}
            </Paper>
        </Popper>
    );
};

export default PopperWrapper;
